module.exports = __webpack_public_path__ + "static/media/blue-cloud-mobile.e5a6d106.png";